import CoachToolsRow from './coach-tools-row'

export { coachToolsRowHasContent } from './coach-tools-row'
export default CoachToolsRow
